export const NEXA_APPLICATION_URL =
  "https://prod.lendingpad.com/nexa/3fbc24ac-f3f7-4c69-8625-3829c31233dc/pos#/account/guest-application";

export const CONTACT = {
  loanOfficer: "Jason Gray",
  nmls: "118354",
  companyNmls: "1660690",
  phoneDisplay: "(425) 260-3482",
  phoneHref: "tel:+14252603482",
  email: "jsgray@nexamortgage.com",
  emailHref: "mailto:jsgray@nexamortgage.com",
  city: "Kirkland, WA",
  addressLine: "1524 Market Street",
  cityStateZip: "Kirkland, WA 98033",
  company: "NEXA Lending",
  companyLegal: "NEXA Mortgage LLC",
};

export const ASSETS = {
  logoHorizontal:
    "https://customer-assets.emergentagent.com/job_check-my-rate/artifacts/4k1bdvge_great-rate-check-logo-transparent.png",
  brandMark:
    "https://customer-assets.emergentagent.com/job_check-my-rate/artifacts/sv3s0rcu_GRC%20-%20clear%20service-mark.png",
  logoMark:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_check-my-rate/artifacts/lncdyk68_Great%20Rate%20Check%20-%20Logo%20Mark.png",
  headshot:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_check-my-rate/artifacts/p09tdtts_Jason%20head%20shot%20blue%20suit.jpg",
  headshotApply:
    "https://customer-assets-4nw71qhi.emergentagent.net/job_check-my-rate/artifacts/3896tmwv_Jason%20Gray%20head%20shot%20black%20shirt%20.jpg",
  familyMoving:
    "https://images.unsplash.com/photo-1758523670991-ee93bc48d81d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  warmInterior:
    "https://images.unsplash.com/photo-1772442363851-738a548f6c5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

// Licensed states — placeholder full national list; user can trim later.
export const LICENSED_STATES =
  "AL, AZ, CA, CO, FL, GA, ID, IL, IN, IA, KS, KY, LA, MI, MN, MS, MO, MT, NE, NV, NH, NJ, NM, NC, ND, OH, OK, OR, PA, SC, SD, TN, TX, UT, VA, WA, WI, WY";

// BDM Overview meeting link — Zoom registration.
export const BDM_MEETING_URL =
  "https://us06web.zoom.us/meeting/register/9_YoNALKSDKG5ea3colxiA#/registration";
